export const GET_WEATHER_START = '@weather/GET_WEATHER_START'
export const GET_WEATHER_SUCCESS = '@weather/GET_WEATHER_SUCCESS'
export const GET_WEATHER_FAILURE = '@weather/GET_WEATHER_FAILURE'

export const GET_WEATHER_TYPES_START = '@weather/GET_WEATHER_TYPES_START'
export const GET_WEATHER_TYPES_SUCCESS = '@weather/GET_WEATHER_TYPES_SUCCESS'
export const GET_WEATHER_TYPES_FAILURE = '@weather/GET_WEATHER_TYPES_FAILURE'

export const RESET_WEATHER = '@weather/RESET_WEATHER'



// WEBPACK FOOTER //
// ./src/screens/weather/actions/types.js